import * as React from 'react';

import UserAvatar, { Props as UserAvatarProps } from 'users/components/UserAvatar';
import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';
import { ReachabilityInfo } from 'components/ReachabilityBadge';

type Props = Omit<UserAvatarProps, 'user'> & { entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity };

export default function IndividualRecipientAvatar(props: Props) {
  const { entity, ...otherProps } = props;
  const { avatar } = entity.content;
  
  const userInfo = avatar.__typename === 'UserInitialsAvatar' ? { initials: avatar.initials } : { profile_picture_url: avatar.imageUrl };
  const reachabilityInfo: ReachabilityInfo | undefined = avatar.reachabilityStatus ? { __typename: 'ReachabilityInfo', status: avatar.reachabilityStatus } : undefined;

  return (
    <UserAvatar {...otherProps} user={{...userInfo, reachabilityInfo}} />
  )
}
